module.exports = __webpack_public_path__ + "assets/Logout.273365e2.svg";